import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import Request from './Request';
/**
 * Fields sent when a fax is logged (see printing-service-runtime `faxUtils.logFax`).
 * The logging service may add identifiers and other fields on read.
 */

/**
 * Read fax activity from the logging service (same host as `LOGGING_SERVICE_URL` in
 * printing-service-runtime, typically `…/api` with path `fax-logs`).
 *
 * Requires the logging service to expose **GET** `/fax-logs?agency=…` (and optional
 * extra query parameters supported by that service).
 */
export class FaxLogs extends Request {
  constructor({
    url,
    keycloak,
    agency,
    signal
  }) {
    super({
      url,
      keycloak,
      signal
    });

    _defineProperty(this, "agency", void 0);

    _defineProperty(this, "keycloak", void 0);

    _defineProperty(this, "commonHeaders", {
      Authorization: '',
      'Content-Type': 'application/json',
      Accept: 'application/json'
    });

    this.url = new URL(url);
    this.keycloak = keycloak;
    this.agency = agency;
    Object.defineProperty(this.commonHeaders, 'Authorization', {
      get() {
        const {
          token
        } = keycloak;
        return `Bearer ${token}`;
      },

      set() {// need a setter
      }

    });
    this.commonHeaders.Authorization = `Bearer ${keycloak.token}`;
  }
  /**
   * GET fax log rows for this agency. Pass optional query keys supported by the
   * logging service (e.g. date range, patient, pagination).
   */


  listFaxLogs(qs = {}) {
    return this.get({
      api: 'fax-logs',
      qs: _objectSpread({
        agency: this.agency
      }, qs)
    });
  }

}
export default FaxLogs;